import React, { useEffect, useState } from "react";
import { Badge, Card, Dropdown, Table } from "react-bootstrap";

import Spinner from "../components/Common/Spinner";

import PageTitle from "../layouts/PageTitle";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment";
import ReportMessages from "../components/Modal/ReportMessages";
import {
  followUp,
  getReportListDetails,
} from "../../services/UserServices/UserService";
import { notifyError, notifyTopRight } from "../components/Common/Toaster";

export default function ReportedByUsers() {
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [reportMessage, setReportMessage] = useState([]);
  const [reportDescription, setReportDescription] = useState("");
  const [isExpanded, setIsExpanded] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);
  const [sentFollowUps, setSentFollowUps] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const location = useLocation();
  const [datas, setDatas] = useState([]);
  // const datas = location?.state?.data;
  const id = location?.state?.id;

  const handleSelectAll = () => {
    setSelectAll(!selectAll);

    if (!selectAll) {
      // Select all report IDs
      const allIds = datas?.map((d) => d?._id);
      setSelectedIds(allIds);
    } else {
      // Unselect all
      setSelectedIds([]);
    }
  };

  async function getTableData() {
    setLoader(true);
    try {
      const response = await getReportListDetails(id);
      setDatas(response.data.data?.reportedBy);
      setLoader(false);
    } catch (error) {
      console.log(error, "error");
      setLoader(false);
    }
  }

  const handleSelectRow = (id) => {
    if (selectedIds.includes(id)) {
      setSelectedIds(selectedIds.filter((item) => item !== id));
      setSelectAll(false);
    } else {
      const updated = [...selectedIds, id];
      setSelectedIds(updated);

      if (updated.length === datas.length) setSelectAll(true);
    }
  };

  const followUpSend = async () => {
    if (selectedIds.length === 0) {
      notifyError("Please select at least one report.");
      return;
    }

    setLoader(true);
    try {
      const response = await followUp({
        subReportIds: selectedIds,
        reportId: id,
      });
      notifyTopRight(response.data?.message);
      getTableData();
      setSelectedIds([]);
      setSelectAll(false);
    } catch (error) {
      notifyError(error?.response?.data?.message);
    }
    setLoader(false);
  };

  useEffect(() => {
    getTableData();
  }, []);

  console.log(selectedIds, "selectedIds");

  return (
    <div>
      <PageTitle
        activeMenu="Users List"
        motherMenu="Reports Management"
        previousPath={"/report-management"}
      />
      <Card>
        <Card.Header
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <Card.Title>Reported By</Card.Title>
          <button
            type="button"
            className="btn btn-primary py-2"
            onClick={followUpSend}
          >
            {loader ? "Sending..." : "Send Follow-Up"}
          </button>
        </Card.Header>
        <Card.Body className=" pt-3">
          {loader ? (
            <Spinner />
          ) : (
            <Table responsive className="mostly-customized-scrollbar mb-0">
              <thead>
                <tr>
                  <th>
                    <input
                      type="checkbox"
                      checked={selectAll}
                      onChange={handleSelectAll}
                      className="form-check-input me-2 conversation-checkbox"
                    />
                  </th>
                  <th>
                    <strong>Name</strong>
                  </th>
                  <th>
                    <strong>Follow Up</strong>
                  </th>
                  <th>
                    <strong>Report Date</strong>
                  </th>
                  <th>
                    <strong>Reason</strong>
                  </th>
                </tr>
              </thead>

              <tbody>
                {datas?.map((item, i) => (
                  <tr key={i}>
                    <td>
                      <input
                        type="checkbox"
                        checked={selectedIds.includes(item?._id)}
                        onChange={() => handleSelectRow(item?._id)}
                        className="form-check-input me-2 conversation-checkbox"
                      />
                    </td>

                    <td
                      className="pointer"
                      onClick={() =>
                        navigate("/user-details", {
                          state: {
                            data: item?.user?._id,
                            selectedTab: "users",
                            search: "search",
                            page: 0,
                            path: "/report-management",
                            from: "reportManagement",
                          },
                        })
                      }
                    >
                      {item?.user ? item?.user?.name : "-"}
                    </td>

                    <td>
                      {item?.isFollowUpMessageSent ||
                      sentFollowUps.includes(item?._id)
                        ? "Follow-Up Sent"
                        : "Follow-Up Pending"}
                    </td>

                    <td>
                      {moment(item?.timestamp).format("MMM Do YYYY, h:mm A")}
                    </td>

                    {item?.reason?.length > 0 && (
                      <td
                        className="pointer"
                        style={{ color: "#007bff" }}
                        onClick={() => {
                          setIsExpanded(true);
                          setReportMessage(item?.reason);
                          setReportDescription(item?.description);
                        }}
                      >
                        Report Messages
                      </td>
                    )}
                  </tr>
                ))}
              </tbody>
            </Table>
          )}
          {datas?.length === 0 && !loader ? (
            <div className="justify-content-center d-flex my-5 ">
              Sorry, Data Not Found!
            </div>
          ) : (
            ""
          )}
        </Card.Body>
      </Card>
      {isExpanded && (
        <ReportMessages
          show={isExpanded}
          text={reportDescription}
          data={reportMessage}
          onHide={() => setIsExpanded(false)}
        />
      )}
    </div>
  );
}
